import { getProfile } from 'store/profile/actions';

export const getPatients = (useRequestState = true) => getProfile('', false, useRequestState);
